import { render } from "./MineComponent.vue?vue&type=template&id=5da132e8&scoped=true"
import script from "./MineComponent.vue?vue&type=script&lang=js"
export * from "./MineComponent.vue?vue&type=script&lang=js"

import "./MineComponent.vue?vue&type=style&index=0&id=5da132e8&scoped=true&lang=css"

import exportComponent from "C:\\www\\farming_chat_pc_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da132e8"]])

export default __exports__